<template>
    <v-dialog v-model="dialogOpen" max-width="400">
      <v-card class="tw-pb-2">
        <v-card-title>ยืนยัน{{topic}}</v-card-title>
        <v-card-text class="tw-tracking-normal tw-text-base tw-h-20">
          คุณแน่ใจหรือไม่ที่ต้องการยืนยัน?
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" class="tw-tracking-normal" @click="onConfirm">ยืนยัน</v-btn>
          <v-btn color="grey darken-1" outlined class="tw-tracking-normal" @click="close">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: "basic-confirm-dialog",
    props: {
      isOpen: Boolean,
      topic: String,
    },
    computed: {
      dialogOpen: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit("update:isOpen", value);
      },
    },
    },
    methods: {
      close() {
        this.$emit("update:isOpen", false);
      },
      onConfirm() {
        this.$emit("confirm");
        this.close();
      },
    },
  };
  </script>
  